export enum ETipoRegraFrete {
    Preco = 1,
    Prazo = 2,
    Impostos = 3,
}
